export interface GuestbookInterface {
  reservationId: string;
  propertyId: string;
  firstName: string;
  lastName: string;
  gender: string;
  birthDate: string;
  country: string;
  documentType: string;
  ttaxType: string;
  documentNumber: string;
  checkintime: string;
  checkouttime: string;
  checkTimesDontUpdateWithReservation: number;
  createdUser: string;
  createdTime: string;
  editedTime: string;
  id?: string;
}

export class Guestbook implements GuestbookInterface {
  reservationId: string;
  propertyId: string;
  firstName: string;
  lastName: string;
  gender: string;
  birthDate: string;
  country: string;
  documentType: string;
  ttaxType: string;
  documentNumber: string;
  checkintime: string;
  checkouttime: string;
  checkTimesDontUpdateWithReservation: number;
  createdUser: string;
  createdTime: string;
  editedTime: string;
  id?: string;
  duplicate: any;
  status: number;

  constructor(data?: GuestbookInterface) {
    Object.assign(this, data);
  }
}
